import { jwtDecode } from "jwt-decode";
import { CacheService } from "core/store/cache-service";

const SPEECH_TOKEN_CACHE_KEY = "SPEECH_TOKEN";
const TOKEN_REFRESH_TIMER_KEY = "TOKEN_REFRESH_TIMER_ID";
const SAFETY_MS = 8000;

export class SpeechTokenCacheService extends CacheService {
    constructor(speechService, sessionStorageCache) {
        super(sessionStorageCache);
        this._speechService = speechService;
    }

    async fetchToken(onRefresh) {
        let token = this._getTokenObj();
        if (token) return token;

        return await this._fetchAndSetToken(onRefresh);
    }

    async _fetchAndSetToken(onRefresh) {
        const tokenResp = await this._speechService.fetchToken();
        const tokenCache = this._createTokenObject(tokenResp);
        this._setTokenObj(tokenCache);
        this._scheduleRefresh(onRefresh, tokenCache);
        return tokenCache;
    }

    _setTokenObj(tokenCache) {
        this.setWithExpiry(SPEECH_TOKEN_CACHE_KEY, tokenCache, this._calculateExpiryDuration(tokenCache));
    }

    _getTokenObj() {
        return this.getWithExpiry(SPEECH_TOKEN_CACHE_KEY);
    }

    _scheduleRefresh(onRefresh, tokenCache) {
        let timeoutId = this.getItem(TOKEN_REFRESH_TIMER_KEY);
        if (timeoutId) {
            this.removeItem(TOKEN_REFRESH_TIMER_KEY);
            clearTimeout(timeoutId)
        }

        const delay = this._calculateDelay(tokenCache);

        timeoutId = setTimeout(async () => {
            try {
                tokenCache = await this._fetchAndSetToken(onRefresh)
                onRefresh?.(tokenCache);
            } catch (err) {
                console.error(err);
            }
        }, delay);

        this.setItem(TOKEN_REFRESH_TIMER_KEY, timeoutId);
    };

    _createTokenObject(tokenResp) {
        return {
            token: tokenResp.token,
            region: tokenResp.region,
            expiresAtMs: new Date(jwtDecode(tokenResp.token).exp * 1000).getTime(),
        };
    };

    _calculateExpiryDuration(tokenCache) {
        return tokenCache.expiresAtMs - Date.now();
    }

    _calculateDelay(tokenCache) {
        return Math.max(0, this._calculateExpiryDuration(tokenCache) - SAFETY_MS);
    }
}
